import React from "react";
import axios from "axios";
import { Loading } from "../components/loading/Loading";
import { IQuotation, TableContent } from "../Types";
import { PageContentLayout } from "../components/home/PageContentLayout";
import { drawerTabs } from "./home/HomeData";

export const Quotations = () => {
  const [content, setContent] = React.useState<TableContent>({
    columns: [],
    data: [],
  });
  const [isLoading, setLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>("");

  const createContent = React.useCallback((data: any) => {
    const content: TableContent = {
        columns: [],
        data: [],
    };

    // Moving thumbnail as first property and removing blogId
    // Calculating columns
    content.columns = Object.keys(data[0]);

    // Calculating data
    data.forEach((item: IQuotation) => {
        content.data.push(Object.values(item));
    });

    setContent(content);
  }, []);

  React.useEffect(() => {
    setLoading(true);
    axios.get(`${process.env.REACT_APP_BASE_URL}/quotations`)
      .then((response) => {
        createContent(response.data);
        setLoading(false);
      }).catch(() => {
        setError("Error fetching quotations");
        setLoading(false);
      });
  }, [createContent]);

  if (isLoading)
    return <Loading />;

  if (error)
    return <>{error}</>;

  return (
    <PageContentLayout
      contentType={drawerTabs[2]}
      tableContent={content!}
    >
    </PageContentLayout>
  );
};
